/**
 * Checks whether the SVG ViewPort should be keps when changing between two scroll images.
 *
 * NOTE: usually the viewport should be reset,
 * but there can be some similar images for which the viewport should not be reset,
 *
 * e.g. the same scene from a different angle.
 */

import { IDisplaySlide } from '@pcp/core/interfaces';

type ModuleId = number;
type SlideId = number;

/**
 * Groups of SlideIds grouped by ModuleId.
 */
const keepViewportCases: Record<ModuleId, Record<SlideId, SlideId>> = {
    203: {
        13691: 13692,
    },
    252: {
        444673: 444759,
    },
};

export const shouldKeepViewport = (
    prevSlide: undefined | IDisplaySlide,
    slide: IDisplaySlide
) => {
    if (
        prevSlide?.id !== undefined &&
        prevSlide?.moduleId !== undefined &&
        prevSlide.id !== slide.id
    ) {
        const edgeCasesInModule = keepViewportCases[prevSlide.moduleId] ?? [];
        const edgeCase =
            edgeCasesInModule[slide.id] || edgeCasesInModule[prevSlide.id];
        if (edgeCase) {
            return edgeCase === prevSlide.id || edgeCase === slide.id;
        }
    }

    return false;
};
